import gql from 'graphql-tag'

export const GetCompendiumGroup = gql`
  query GetCompendiumGroup($providerId: MongoID!, $id: ID!) {
    getCompendiumGroup(providerId: $providerId, id: $id) {
      tests {
        _id
        result {
          name
          code
        }
      }
    }
  }
`

export const GetPackage = gql`
  query GetPackage($id: MongoID!) {
    getPackage(id: $id) {
      name
      ls_price
      partner_price
      additional_fee
      retail_price
      provider {
        _id
      }
      categories {
        category {
          _id
          name
        }
        panels {
          code
          name
          price
          retail_price
          contract_price
          tests {
            _id
            order {
              name
              code
            }
            result {
              name
              code
            }
          }
        }
      }
      marketing {
        summary
        details
        subtitle
        cover_image {
          url
        }
      }
      is_private
      provider {
        _id
      }
    }
  }
`

export const ListPackages = gql`
  query ListPackages($page: NonNegativeInt, $filter: PackageFilter, $sort: PackageSort) {
    listPackages(limit: 40, page: $page, filter: $filter, sort: $sort) {
      packages {
        _id
        name
        ls_price
        partner_price
        retail_price
        categories {
          category {
            name
            subtitle
            icon {
              url
            }
            summary
            details
          }
          panels {
            name
            code
            tests {
              order {
                name
              }
              result {
                code
                name
              }
              meta {
                loinc
              }
            }
            aoe {
              _id
              question
              choices {
                code
                value
              }
              type
              is_required
            }
          }
        }
        created_by {
          name {
            display
          }
        }
        updated_by {
          name {
            display
          }
        }
        provider {
          name
        }
        marketing {
          summary
          details
        }
        is_private
      }
      page
      pages
      total
    }
  }
`

export const ListPartnerProjectPackages = gql`
  query ListPartnerProjectPackages(
    $partnerId: MongoID!
    $projectId: MongoID!
    $providerId: MongoID!
    $limit: PositiveInt = 40
    $filter: NameFilter
    $sort: NameSort
    $page: NonNegativeInt = 1
  ) {
    listPartnerProjectPackages(
      partner_id: $partnerId
      project_id: $projectId
      provider_id: $providerId
      limit: $limit
      filter: $filter
      sort: $sort
      page: $page
    ) {
      page
      pages
      total
      packages {
        name
        commission
        package {
          _id
          name
          ls_price
          partner_price
          retail_price
          categories {
            category {
              name
              subtitle
              icon {
                url
              }
              summary
              details
            }
            panels {
              name
              code
              price
              retail_price
              contract_price
              tests {
                order {
                  name
                }
                result {
                  code
                  name
                }
                meta {
                  loinc
                }
              }
              aoe {
                _id
                question
                choices {
                  code
                  value
                }
                type
                is_required
              }
            }
          }
          created_by {
            _id
            name {
              display
            }
          }
          updated_by {
            name {
              display
            }
          }
          provider {
            name
          }
          marketing {
            summary
            details
          }
          is_private
        }
      }
    }
  }
`

export const ListCompendiumPanels = gql`
  query ListCompendiumPanels(
    $limit: PositiveInt
    $page: PositiveInt = 1
    $type: CompendiumPanelTypeEnum!
    $search: RegExp
    $providerId: MongoID!
    $sort: CompendiumSort
    $removeZeroPriceTests: Boolean
  ) {
    listCompendiumPanels(
      limit: $limit
      page: $page
      filter: { type: $type, providerId: $providerId, search: $search, removeZeroPriceTests: $removeZeroPriceTests }
      sort: $sort
    ) {
      compendium_panels {
        name
        code
        price
        retail_price
        contract_price
        tests {
          _id
          order {
            name
            code
          }
          result {
            name
            code
          }
        }
      }
      page
      pages
      total
    }
  }
`
export const ListPackageCategories = gql`
  query ListPackageCategories($limit: PositiveInt = 50, $page: PositiveInt = 1, $filter: PackageCategoryFilter, $sort: PackageCategorySort) {
    listPackageCategories(limit: $limit, page: $page, filter: $filter, sort: $sort) {
      package_categories {
        _id
        name
        icon {
          url
        }
        completed
      }
      page
      pages
      total
    }
  }
`
